import React, { useEffect } from "react";
import Layout from "../Layout";
import { useTranslation } from "react-i18next";
import { indexStore } from "../../../store/indexStore";
import { motion } from "framer-motion";
import { FileText, Loader2 } from "lucide-react";
import { BodyPage } from "../TermsOfService/TermsOfService";

function PrivacyPolicy() {
  const { t } = useTranslation();
  const { lang, privacyPolicy, privacyPolicyLoading, fetchPrivacyPolicyAction } = indexStore();

  useEffect(() => {
    // جلب البيانات فقط إذا لم تكن موجودة
    if (!privacyPolicy) {
      fetchPrivacyPolicyAction();
    }
  }, [privacyPolicy, fetchPrivacyPolicyAction]);

  // الحصول على المحتوى حسب اللغة
  const getContent = () => {
    if (!privacyPolicy) return null;
    const content = lang === "ar" ? privacyPolicy.ar?.content : privacyPolicy.en?.content;
    return content || null;
  };

  const content = getContent();

  return (
    <Layout title={t("pages.privacyPolicy")}>
      <div className="min-h-screen bg-gradient-to-br from-background via-muted/30 to-background">
        {/* Hero Section */}
        <section className="py-8 md:py-12 lg:py-16 relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-primary/3 to-primary/5"></div>
          <div className="absolute top-0 right-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl"></div>

          <div className="relative max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-center mb-10 md:mb-14"
            >
              <div className="flex justify-center items-center gap-2">
                <div className="p-4 bg-primary/10 rounded-2xl">
                  <FileText className="w-8 h-8 md:w-10 md:h-10 text-primary" />

                </div>
                <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4">
                  <span className="bg-gradient-to-r from-primary via-primary/90 to-primary bg-clip-text text-transparent">
                    {t("pages.privacyPolicy")}
                  </span>
                </h1>
              </div>

            </motion.div>
          </div>
        </section>

        {/* Content Section */}
        <section className="py-8 md:py-12 lg:py-16">
          <div className="w-full mx-auto px-4 md:px-6 lg:px-8">
            {privacyPolicyLoading ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                className="flex flex-col items-center justify-center py-20"
              >
                <Loader2 className="w-12 h-12 text-primary animate-spin mb-4" />
                <p className="text-muted-foreground">{t("gloabl.loading")}</p>
              </motion.div>
            ) : content ? (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="bg-card rounded-xl md:rounded-2xl border-2 border-border/50 shadow-lg p-6 md:p-8 lg:p-10"
              >
                <div
                  className="prose prose-lg dark:prose-invert max-w-none prose-headings:text-foreground prose-p:text-muted-foreground prose-strong:text-foreground prose-a:text-primary hover:prose-a:text-primary/80 prose-ul:text-muted-foreground prose-ol:text-muted-foreground"
                  dangerouslySetInnerHTML={{ __html: content }}
                />
              </motion.div>
            ) : (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="bg-card rounded-xl md:rounded-2xl border-2 border-border/50 shadow-lg p-6 md:p-8 text-center"
              >
                <p className="text-muted-foreground text-lg">
                  {t("gloabl.noDataAvailable") || "No data available"}
                </p>
              </motion.div>
            )}
          </div>
        </section>
        <BodyPage content={content} />
      </div>
    </Layout>
  );
}

export default PrivacyPolicy;
